export default __webpack_public_path__ + "static/media/work-energy.a9638dbc.png";